/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
    SortDirectionToJSONTyped,
} from './SortDirection';
import type { SearchSorting } from './SearchSorting';
import {
    SearchSortingFromJSON,
    SearchSortingFromJSONTyped,
    SearchSortingToJSON,
    SearchSortingToJSONTyped,
} from './SearchSorting';

/**
 * 
 * @export
 * @interface SearchSortingRequestDto
 */
export interface SearchSortingRequestDto {
    /**
     * 
     * @type {SearchSorting}
     * @memberof SearchSortingRequestDto
     */
    sortBy?: SearchSorting;
    /**
     * 
     * @type {SortDirection}
     * @memberof SearchSortingRequestDto
     */
    sortDir?: SortDirection;
}



/**
 * Check if a given object implements the SearchSortingRequestDto interface.
 */
export function instanceOfSearchSortingRequestDto(value: object): value is SearchSortingRequestDto {
    return true;
}

export function SearchSortingRequestDtoFromJSON(json: any): SearchSortingRequestDto {
    return SearchSortingRequestDtoFromJSONTyped(json, false);
}

export function SearchSortingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSortingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sortBy': json['sortBy'] == null ? undefined : SearchSortingFromJSON(json['sortBy']),
        'sortDir': json['sortDir'] == null ? undefined : SortDirectionFromJSON(json['sortDir']),
    };
}

export function SearchSortingRequestDtoToJSON(json: any): SearchSortingRequestDto {
    return SearchSortingRequestDtoToJSONTyped(json, false);
}

export function SearchSortingRequestDtoToJSONTyped(value?: SearchSortingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortBy': SearchSortingToJSON(value['sortBy']),
        'sortDir': SortDirectionToJSON(value['sortDir']),
    };
}

